// Third Party Imports
import React from 'react';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';

// Relative Imports
import AlertBox from '../Alert/Alert';
import './MasterBrand.less';

export default class MasterBrandPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    processBrandName() {
        const {brandName} = this.props; 
        if (brandName.indexOf('.') > -1) {
            return brandName.substring(0, brandName.indexOf('.'));
        }
        return brandName;
    }

    render() {
        const {errorKey,
            translations,
            handleContinueButtonClick,
            handleBackButtonClick,
            triggerEdapEvent,
            handleAlertDismiss,
            hostName
        } = this.props;
        const brandNameModified = this.processBrandName();

        return (
            <div id="masterBrand" className="master-brand">
                <div className="master-brand-container">
                    <div className="wrapper">
                        <div className="content-holder">
                            {
                                (errorKey)
                                    ? <div className="alert-panel">
                                        <AlertBox
                                            messageKey={errorKey}
                                            translations={translations}
                                            handleAlertDismiss={handleAlertDismiss}
                                            size={'sm'}
                                        />
                                    </div>
                                    : null
                            }
                            <div className="panel-head">
                                <h1 className="head">{translations['ipmob.masterbrand.heading']}</h1>
                                <span className="sub-head-grey">{translations['ipmob.masterbrand.sub_heading_1']}</span>
                            </div>
                            {
                                <div className="master-brand-site">
                                    <h5 className="master-brand-subheading2"> {translations['ipmob.masterbrand.sub_heading_2']} </h5>
                                    <p className="brand">{`${brandNameModified} (${hostName})`}</p>
                                </div>
                            }
                        </div>
                    </div>
                    <ContinueButtonHolder
                        handleContinueButtonClick={handleContinueButtonClick}
                        enableContinueButton
                        translations={translations}
                        continueButtonId={'masterBrandPageContinueBtn'}
                        triggerEdapEvent={triggerEdapEvent}
                        enableBackButton
                        handleBackButtonClick={handleBackButtonClick}
                    />
                </div>
            </div>
        );
    }
}
